import { IParamsFile } from '../models'
import { IAppSpinner } from '../services/AppSpinner'
import { IUserTracking } from '../services/UserTracking'

const SET_CONTEXT = 'context/SET_CONTEXT'
const SET_ERROR = 'context/SET_ERROR'
const SET_PARAMS_DYNAMIC = 'context/SET_PARAMS_DYNAMIC'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IStore<T = any, S = any, P = IParamsFile> {
  context: IContext<T, S, P>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IContext<T = any, S = any, P = IParamsFile> {
  appName: string
  appSpinner: IAppSpinner
  error?: boolean
  paramsDynamic?: T
  paramsFile?: P
  paramsStatic?: S
  loggly?: any
  userTracking?: IUserTracking
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const contextReducer = (context: IContext, action: any): IContext => {
  switch (action.type) {
    case SET_ERROR: {
      return { ...context, error: action.error }
    }
    case SET_PARAMS_DYNAMIC: {
      return { ...context, paramsDynamic: action.data }
    }
    case SET_CONTEXT: {
      return { ...action.context }
    }
    default: {
      return { ...context }
    }
  }
}

export const setError = (error: boolean) => {
  return {
    type: SET_ERROR,
    error
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setParamsDynamic = (data: any) => {
  return {
    type: SET_PARAMS_DYNAMIC,
    data
  }
}

export const setContext = (context: IContext) => {
  return {
    type: SET_CONTEXT,
    context
  }
}
